

document.querySelectorAll( '[data-scroll]' ).forEach( el => {
  const selector = el.dataset.scroll;
  const target = document.querySelector( selector );
  el.addEventListener( 'click', () => {
    target.scrollIntoView();
  } );
} );

document.querySelectorAll( '[data-cf7-form]' ).forEach( button => {
  const formElementID = button.dataset.cf7Form;
  const formSubmit = document.querySelector( `#${formElementID} .wpcf7-submit` );
  // Allow other event handlers to run before form is submitted
  button.addEventListener( 'click', () => requestAnimationFrame(
    () => formSubmit.click()
  ) );
} );